




































































































































































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import { mapActions } from 'vuex';
import _, { cloneDeep } from 'lodash';
import { Getter } from 'vuex-class';
import { Refs } from '@/types';
import { alphanumericControl, numericControl, addressControl, nameControl } from '@/services/textInputControl';
import { SaisieInfosContactType } from './types';
import { CodePostal } from '@/store/codePostal/types';
import { Watch } from 'vue-property-decorator';
import MixinVaccinationRules from '@/mixins/MixinVaccinationRules';

const Props = Vue.extend({
	props: {
		isEmergencyMode: {
			type: Boolean,
			required: true
		},
		infosContact: {
			type: Object as () => SaisieInfosContactType,
			default: undefined
		},
		isEditionMode: {
			type: Boolean,
			default: false
		}
	}
});

@Component({
	methods: {
		...mapActions('globalState', ['addLoading', 'removeLoading']),
		...mapActions('codesPostaux', ['loadCodesPostaux'])
	}
})
export default class SaisieInfosContact extends mixins(MixinVaccinationRules, Props) {
	@Getter('codesPostaux/getListCodesPostaux') listCodesPostaux!: CodePostal[];

	$refs!: Refs<{
		contactPatientForm: HTMLFormElement;
	}>;

	alphanumControl = alphanumericControl;
	numControl = numericControl;
	nameControl = nameControl;
	addressControl = addressControl;
	allowValidation = false;

	searchSync = '';
	filteredList: CodePostal[] = [];

	codePostalLocalite = '';

	contactPatient: SaisieInfosContactType = {
		hebergeant: '',
		telephone: '',
		email: '',
		voie: '',
		codePostal: '',
		localite: '',
		complementAdresse: '',
		lieuDit: ''
	};

	@Watch('searchSync')
	searchTrigger(val: string) {
		if (_.isEmpty(val) || _.size(val) < 2) {
			this.filteredList = [];
		} else {
			const valUpperCase = val.toUpperCase();
			const allResult = _.sortBy(_.filter(this.listCodesPostaux,
				({ libelleAffichage }) => libelleAffichage.toUpperCase().includes(valUpperCase)
			), ['codePostal', 'libelle']);
			const codePostalStart = _.filter(allResult,
				({ codePostal }) => codePostal.startsWith(valUpperCase)
			);
			const villeStart = _.filter(allResult,
				({ libelle }) => libelle.startsWith(valUpperCase)
			);
			this.filteredList = _.uniqBy(_.concat(codePostalStart, _.concat(villeStart, allResult)), 'codePostalId');
		}
	}

	get isEmailEmpty() {
		return _.isEmpty(this.contactPatient.email);
	}

	validerSaisieContactForm(): Promise<boolean> {
		return new Promise((resolve, reject) => {
			Promise.all([this.allowValidation = true]).then(() => {
				resolve(this.$refs.contactPatientForm.validate());
			});
		});
	}

	changeCodePostalValue() {
		this.contactPatient.codePostal = _.get(this.codePostalLocalite, 'codePostal', '');
		this.contactPatient.localite = _.get(this.codePostalLocalite, 'libelle', '');
	}

	getInfosContact() {
		return this.contactPatient;
	}

	created() {
		if (_.isEmpty(this.listCodesPostaux)) {
			this.addLoading();
			this.loadCodesPostaux().finally(() => this.removeLoading());
		}
		if (this.infosContact) {
			this.contactPatient = cloneDeep(this.infosContact);
			if (this.infosContact.codePostal && this.infosContact.localite) {
				this.codePostalLocalite = this.contactPatient.codePostal + ' - ' + this.contactPatient.localite;
			}
		}
	}

	reset() {
		this.$refs.contactPatientForm.reset();
	}

}
